module.exports = __webpack_public_path__ + "static/media/user-parcels-empty.ca893891.png";